export default "__VITE_ASSET__ChTTSnZr__"